var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visa_secure",
    "data-name": "visa secure",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 99,
    height: 43,
    viewBox: "0 0 99 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161253",
    "data-name": "Rectangle 161253",
    width: 38,
    height: 31,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161403",
    "data-name": "Rectangle 161403",
    width: 99,
    height: 43,
    rx: 5,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_174181",
    "data-name": "Group 174181",
    transform: "translate(31.999 4.999)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161251",
    "data-name": "Rectangle 161251",
    width: 38,
    height: 31,
    transform: "translate(0 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161252",
    "data-name": "Rectangle 161252",
    width: 36.035,
    height: 18.37,
    transform: "translate(1.064 12.217)",
    fill: "#070606"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_173797",
    "data-name": "Group 173797",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_173796",
    "data-name": "Group 173796",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38061",
    "data-name": "Path 38061",
    d: "M35.244,26.995l-3.59,6.9H29.311l-1.767-5.506a.787.787,0,0,0-.526-.606,10.88,10.88,0,0,0-2.186-.587l.052-.2h3.771a1,1,0,0,1,1.022.7l.933,3.992,2.305-4.7Zm9.178,4.647c.01-1.821-3.125-1.922-3.1-2.735.007-.247.3-.51.94-.578a5.1,5.1,0,0,1,2.186.309l.388-1.464a7.263,7.263,0,0,0-2.073-.3c-2.191,0-3.732.937-3.744,2.28-.014.993,1.1,1.547,1.939,1.878.864.338,1.154.555,1.15.857-.006.463-.689.668-1.325.675a5.538,5.538,0,0,1-2.276-.436l-.4,1.512A8.177,8.177,0,0,0,40.563,34c2.329,0,3.852-.926,3.859-2.361m5.785,2.252h2.049l-1.79-6.9h-1.89a1.035,1.035,0,0,0-.944.506l-3.325,6.393h2.327l.462-1.03h2.843ZM47.733,31.45,48.9,28.859l.671,2.591ZM38.41,26.995l-1.832,6.9H34.362l1.832-6.9Z",
    transform: "translate(-20.039 -21.825)",
    fill: "#070606"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38062",
    "data-name": "Path 38062",
    d: "M41.289,133.5a.821.821,0,0,1,.2-.558,1.22,1.22,0,0,1,.543-.346,2.409,2.409,0,0,1,.776-.117,3.146,3.146,0,0,1,.77.075,2.332,2.332,0,0,1,.44.153l.051.577h-.017a1.537,1.537,0,0,0-.35-.169,2.952,2.952,0,0,0-.44-.117,2.5,2.5,0,0,0-.46-.043,1.5,1.5,0,0,0-.58.094.331.331,0,0,0-.222.327.368.368,0,0,0,.1.279.783.783,0,0,0,.316.165q.21.064.523.133.3.064.554.131a1.9,1.9,0,0,1,.452.174.771.771,0,0,1,.415.735.913.913,0,0,1-.429.813,2.181,2.181,0,0,1-1.2.281,3.686,3.686,0,0,1-.779-.085,2.209,2.209,0,0,1-.637-.227l-.045-.581h.017a2.3,2.3,0,0,0,.682.3,3,3,0,0,0,.8.11q.858,0,.858-.476a.392.392,0,0,0-.1-.275.728.728,0,0,0-.313-.176,5.5,5.5,0,0,0-.562-.144q-.273-.059-.517-.128a1.951,1.951,0,0,1-.438-.179.851.851,0,0,1-.3-.284.814.814,0,0,1-.111-.444",
    transform: "translate(-33.311 -111.052)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38063",
    "data-name": "Path 38063",
    d: "M60.27,136.375V132.9h2.785v.5H61.032v.929h1.6v.485h-1.6v1.057h2.023v.5Z",
    transform: "translate(-48.65 -111.401)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38064",
    "data-name": "Path 38064",
    d: "M77.4,134.286a1.291,1.291,0,0,0,.179.687,1.182,1.182,0,0,0,.514.453,1.858,1.858,0,0,0,.807.16,2.354,2.354,0,0,0,.8-.117,2.016,2.016,0,0,0,.557-.3h.017l-.08.609a2.6,2.6,0,0,1-.591.227,3.158,3.158,0,0,1-.8.089,2.818,2.818,0,0,1-.918-.139,2.11,2.11,0,0,1-.693-.385,1.649,1.649,0,0,1-.438-.574,1.73,1.73,0,0,1,0-1.412,1.655,1.655,0,0,1,.438-.572,2.117,2.117,0,0,1,.69-.385,2.774,2.774,0,0,1,.909-.139,3.557,3.557,0,0,1,.784.075,1.891,1.891,0,0,1,.563.217l.079.623H80.21a1.915,1.915,0,0,0-.563-.3,2.309,2.309,0,0,0-.756-.112,1.839,1.839,0,0,0-.8.16,1.166,1.166,0,0,0-.509.453,1.307,1.307,0,0,0-.176.687",
    transform: "translate(-61.843 -111.052)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38065",
    "data-name": "Path 38065",
    d: "M100.282,135.917a1.416,1.416,0,0,0,.852-.2.819.819,0,0,0,.267-.694V132.9h.636v2.156a1.213,1.213,0,0,1-.458,1.06,2.277,2.277,0,0,1-1.333.327,2.406,2.406,0,0,1-1.353-.325,1.186,1.186,0,0,1-.483-1.062V132.9h.762v2.11a.854.854,0,0,0,.259.7,1.352,1.352,0,0,0,.85.21",
    transform: "translate(-79.443 -111.401)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38066",
    "data-name": "Path 38066",
    d: "M121.1,136.375V132.9h1.824a1.807,1.807,0,0,1,.736.137,1.1,1.1,0,0,1,.474.378.938.938,0,0,1,.165.543.889.889,0,0,1-.244.622,1.205,1.205,0,0,1-.665.353l1.108,1.446h-.875l-1-1.364h-.762v1.364Zm1.62-2.994h-.858v1.172h.858a.982.982,0,0,0,.6-.144.62.62,0,0,0,0-.883.981.981,0,0,0-.6-.144",
    transform: "translate(-97.759 -111.401)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38067",
    "data-name": "Path 38067",
    d: "M141.689,136.375V132.9h2.785v.5H142.45v.929h1.6v.485h-1.6v1.057h2.023v.5Z",
    transform: "translate(-114.383 -111.401)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaSecure);
export default __webpack_public_path__ + "static/media/visa-secure.a7296ae6d6e5a7d0e331a61c24dfce9f.svg";
export { ForwardRef as ReactComponent };